import { SlimFeature, SlimFeatureType } from '@islandsstofa/react'
import React, { FC } from 'react'

interface Props {
  features: SlimFeatureType[]
}

const SlimFeatureList: FC<Props> = ({ features }) => {
  return (
    <div>
      {features.map(feature => (
        <SlimFeature {...feature} />
      ))}
    </div>
  )
}

export default SlimFeatureList
